import { render, staticRenderFns } from "./keyIndicator.vue?vue&type=template&id=13255081&scoped=true&"
import script from "./keyIndicator.vue?vue&type=script&lang=js&"
export * from "./keyIndicator.vue?vue&type=script&lang=js&"
import style0 from "./keyIndicator.vue?vue&type=style&index=0&id=13255081&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13255081",
  null
  
)

export default component.exports